import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootSaga from '../sagas/index';
import rootReducer from '../reducers/index';
import middleware, { sagaMiddleware } from './middleware';

const persistConfig = {
  key: 'wprj', // key is required
  storage, // storage is now required
  whitelist: ['app', 'user'],
};

const reducer = persistReducer(persistConfig, combineReducers({ ...rootReducer }));

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/* istanbul ignore next */
const configStore = (initialState = {}) => {
  const store = createStore(reducer, initialState, composeEnhancer(applyMiddleware(...middleware)));

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('reducers', () => {
      const nextRootReducer = require('../reducers/index').default;
      store.replaceReducer(persistReducer(persistConfig, nextRootReducer));
    });
  }

  return {
    persistor: persistStore(store),
    store,
  };
};

const { store, persistor } = configStore();

global.store = store;

export { store, persistor };
